<div class="d-flex flex-column gap-2">
  <div class="d-flex justify-content-between align-items-center w-100 pt-2">
    <ix-typography format="display"
      >{{ 'general.filter' | translate }}
    </ix-typography>
    <ix-pill [outline]="true" variant="neutral">
      {{ numberOfFoundPassports }} {{ 'dpp.general.results' | translate }}
    </ix-pill>
  </div>

  <ix-input
    class="w-100 pt-4"
    [label]="'dpp.general.passport_name' | translate"
    name="passportName"
    [(ngModel)]="criteria.passportName"
    #passportName
    (ngModelChange)="onCriteriaChange()"
    >
    @if (passportName.value) {
      <ix-icon-button
        (click)="onClearSearch('passportName')"
        variant="tertiary"
        icon="clear"
        id="clear-button-name"
        onkeypress=""
        size="16"
        slot="end"
        />
    }
  </ix-input>

  <ix-input
    class="w-100"
    [label]="'dpp.general.aas_id' | translate"
    name="aasId"
    [(ngModel)]="criteria.aasId"
    #aasId
    (ngModelChange)="onCriteriaChange()"
    >
    @if (aasId.value) {
      <ix-icon-button
        (click)="onClearSearch('aasId')"
        variant="tertiary"
        icon="clear"
        id="clear-button-aas"
        onkeypress=""
        size="16"
        slot="end"
        />
    }
  </ix-input>

  <ix-input
    class="w-100"
    [label]="'dpp.general.global_asset_id' | translate"
    name="globalAssetId"
    [(ngModel)]="criteria.globalAssetId"
    #globalAssetId
    (ngModelChange)="onCriteriaChange()"
    >
    @if (globalAssetId.value) {
      <ix-icon-button
        (click)="onClearSearch('globalAssetId')"
        variant="tertiary"
        icon="clear"
        id="clear-button-global"
        onkeypress=""
        size="16"
        slot="end"
        />
    }
  </ix-input>
</div>
